import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  filterLineName,
  filterPlantName,
  filterShopName,
  timeTnterval,
} from "src/redux/features";
import { SubHeader, ListView, ToolsListView } from "src/layouts";
import {
  LANDING_PAGE_MODULE_CODE,
  Title,
  commonVaribles,
} from "src/constants/constVariables";

import styles from "./IndexPage.module.scss";
import { useSelector } from "react-redux";
import { baseApiCall } from "src/api/Api";
import { external_service } from "src/constants/url";

export const IndexPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectOption, setSelectOption] = useState([]);
  //eslint-disable-next-line
  const [selectedColumnsQueue, setSelectedColumsQueue] = useState([]);

  const plantDataList = useSelector((state) => state.allPlants.plants);

  useEffect(() => {
    dispatch(filterShopName());
    dispatch(filterLineName());
    getTimeInterval();
  }, []);

  const getTimeInterval = () => {
    baseApiCall({
      url: external_service.GET_MASTER_PARAMETER,
      requestBody: {
        key: [
          "notification_time_interval",
          "dashboard_time_interval",
          "sequence_time_interval",
          "alert_time_interval",
        ],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result) {
          const data = res.data.result;
          dispatch(timeTnterval(data));
        }
      },
      onFailure: () => {},
      errorCall: () => {},
    });
  };

  const getToolOptions = () => [
    {
    	label: Title.dashboard,
    	action: () => {
    		navigate('/dashboard');
    	},
    	privilege: LANDING_PAGE_MODULE_CODE.dashboard
    },
    {
      label: Title.packaging_strategy,
      action: () => {
        navigate("/packaging-strategy");
      },
      privilege: LANDING_PAGE_MODULE_CODE.packaging_strategy,
    },
    // {
    // 	label: Title.usage_analytics,
    // 	action: () => {
    // 		navigate('/usage-analytics');
    // 	},
    // 	privilege: LANDING_PAGE_MODULE_CODE.usage_analytics,
    // }
    {
    	label: Title.mis_reports,
    	action: () => {
    		navigate('/mis-reports');
    	},
    	privilege: LANDING_PAGE_MODULE_CODE.mis_reports
    },
    {
    	label: Title.user_management,
    	action: () => {
    		navigate('/user-management');
    	},
    	privilege: LANDING_PAGE_MODULE_CODE.user_management
    },
    // {
    //   label: Title.user_manual,
    //   action: () => {
    //     navigate('/user-manual');
    //   },
    //   privilege: LANDING_PAGE_MODULE_CODE.user_manual
    // }
  ];

  const getSelectOptions = [];
  const toolOptions = getToolOptions();

  const selectOptions = () => {
    setSelectOption(getSelectOptions);
  };

  // const selectOptionsForDashboard = () => {
  // 	setSelectOption(getSelectOptionsForDashboard);
  // };

  const handleFilterValue = async (value) => {
    dispatch(filterPlantName(value));
  };

  const handleSelection = (selection) =>
    setSelectedColumsQueue((prev) => {
      if (prev.length) {
        const lastSelection = prev[prev.length - 1];
        if (lastSelection === selection) return prev;
        while (prev.length) {
          const existingTopLevel = prev[prev.length - 1].level;
          if (existingTopLevel >= selection.level) prev.pop();
          else break;
        }
      }
      prev.push(selection);
      return [...prev];
    });

  return (
    <div className={styles.container}>
      <div style={{ marginBottom: "1em" }}>
        <SubHeader
          title={Title.logistics_and_packaging}
          data={plantDataList}
          filter={handleFilterValue}
        />
      </div>
      <div className={styles.columnsContainer}>
        {/* <div style={{ height: "100%" }} className={styles.columnsContainerLeft}>
          <ListView title="Select" />
        </div> */}
        <div className={styles.toolsColumn} style={{ height: "90%"}}>
          <ToolsListView
            listItems={toolOptions}
            handleSelection={handleSelection}
          />
        </div>
      </div>
    </div>
  );
};
